import AjaxForm from '../../utilities/ajax-form';
import AjaxReloadPartial from '../../utilities/AjaxReloadPartial';
import CheckoutAccordions from './CheckoutAccordions';
import {CheckoutFormNotification} from '../../utilities/notifications/checkout-form';

export default class UpdateCartBillingShipping extends AjaxForm { // Step #1
  handleSuccess(json) {
    try {
      if (json.cart?.shippingAddress?.postalCode && globals.excludePostcodes.includes(json.cart?.shippingAddress?.postalCode)) {
          this.promptInvalidPostcode();
      } else {
          new AjaxReloadPartial('.js-update-checkout', function() {
              new CheckoutAccordions('.js-payment-details').open();
          });
      }
    } catch (error) {
        console.error('An error occurred:', error);
    
        // Ensure the modal opens even if there was an error
        new AjaxReloadPartial('.js-update-checkout', function() {
            new CheckoutAccordions('.js-payment-details').open();
        });
    }

  }
  handleErrors(json) {
    try {
      if (json.cart?.shippingAddress?.postalCode && globals.excludePostcodes.includes(json?.shippingAddress?.postalCode)) {
        this.promptInvalidPostcode();
      }

      if(document.querySelector('.checkout__form-address--shipping .js-msg-error') !== null) {
        document.querySelector('.checkout__form-address--shipping .js-msg-error').remove();
      }

      this.addErrorsToFormInputs(json.errors);
    } catch (error) {
      this.addErrorsToFormInputs(json.errors);
    }
  }

  promptInvalidPostcode() {


    new CheckoutFormNotification({
      type: 'success',
      message: `<p>Unfortunately, we are not able to supply to certain areas within Australia due to Responsible service of Alcohol, liquor licensing laws and regulations.</p>
      <p>
      To find out more about where we can and can not deliver to please visit our Shipping Info page</p>`,
      appendTo: document.querySelector('.checkout__form-address--shipping'),
      notificationClass: 'js-msg-error'
    });
    window.scrollTo(0,0); 
  }
};